import React from 'react';

const RejectConfirm = (
  () => {
    return <div style={{ marginTop: '20px' }}>La demande de création de compte a bien été rejetée.</div>;
  }
);

export default RejectConfirm;
